import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.15 }}
        transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <div className={`mb-6 flex items-center gap-3 ${className}`}>
        <span className="h-px w-9 bg-gradient-to-r from-cyber to-transparent" />
        <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-cyber">
            {children}
        </span>
    </div>
);

export const CountUp = ({ to, decimals = 2, duration = 1.8, prefix = "", suffix = "" }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, amount: 0.6 });
    const [v, setV] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const t0 = performance.now();
        let raf;
        const tick = (t) => {
            const p = Math.min(1, (t - t0) / (duration * 1000));
            setV(to * (1 - Math.pow(1 - p, 3)));
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, to, duration]);

    return (
        <span ref={ref} className="tabular-nums">
            {prefix}
            {v.toLocaleString("en-US", {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            })}
            {suffix}
        </span>
    );
};
